import { Map } from 'mapbox-gl'
import { inject, InjectionKey, provide, Ref, ref } from 'vue'

export const MapKey = Symbol() as InjectionKey<Ref<Map | undefined>>

export const provideMap = () => {
  const mapRef = ref<Map | undefined>()

  // NB `any` workaround for recursive type issue https://stackoverflow.com/q/70545982
  const setMapState = (map: Map) => {
    mapRef.value = map
  }
  provide(MapKey, mapRef)

  return { mapRef, setMapState }
}

// For convenience, assert non-null `inject` and cast the `any` workaround from provideMap.
// NOTE: useMap() *must* be called in the component tree within the <Map> component's <slot>
export default function useMap(): Map {
  return inject(MapKey)!.value!
}

// Check if a given component is within the map context,
//   (for components that may be mounted elsewhere).
export const useHasMapContext = (): boolean => {
  const mapContext = inject(MapKey, undefined)?.value
  return !!mapContext
}
